import React, { useState } from 'react';
import styles from './Search.module.scss';
import SearchIcon from '@mui/icons-material/Search';

const Search = ({ target, search, setSearch }) => {
	const [expandSearch, setExpandSearch] = useState(false);

	const handleSearch = (e) => {
		setSearch(e.target.value);
	};

	return (
		<div
			className={`${styles.search_icon} ${
				expandSearch === true && styles.open
			}`}
		>
			<input
				className={styles.search_icon__input}
				placeholder={`Search ${target}`}
				value={search}
				onChange={(e) => handleSearch(e)}
				type='text'
				name=''
			/>

			<div
				className={styles.search_icon__wrapper}
				onClick={() => {
					setExpandSearch(!expandSearch);
					setSearch('');
				}}
			>
				<div className={styles.search_icon__glass}></div>
				<div className={styles.search_icon__handle}></div>
			</div>
		</div>
	);
};

export default Search;
